import EmptyState from "@/common/components/EmptyState";

interface UserFlagsEmptyStateProps {
  isLoading?: boolean;
  isError?: boolean;
  onRetry?: () => void;
}

export function UserFlagsEmptyState({
  isLoading,
  isError,
  onRetry,
}: UserFlagsEmptyStateProps) {
  if (isLoading) {
    return <EmptyState isLoading={isLoading} />;
  }

  if (isError) {
    return (
      <EmptyState
        isError={isError}
        onRetry={onRetry}
        title="Failed to load flags"
        description="There was an error loading the user's flags. Please try again."
      />
    );
  }

  return (
    <EmptyState
      title="No flags found"
      description="This user has not been exposed to any flags yet."
    />
  );
}
